// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scramble-dialog__wrapper{color:#636c78;font-family:PingFang SC;font-style:normal;font-weight:400;font-size:14px;line-height:22px}.scramble-dialog__tips{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
